import type { PersonaDto } from '@reelplicate/api-client/model';
import {
  createPersonaBodyNameMax,
  createPersonaBodyShortNameMax,
  createPersonaBodyVoiceMax,
} from '@reelplicate/api-client/zod/personas';
import { z } from 'zod';

/**
 * A persona's name, short name, voice and time zone ("" for the
 * workspace's), as the forms edit them.
 */
export const PersonaSchema = z.object({
  name: z
    .string()
    .trim()
    .min(1, 'Name the persona')
    .max(
      createPersonaBodyNameMax,
      `Keep it under ${createPersonaBodyNameMax} characters`,
    ),
  shortName: z
    .string()
    .trim()
    .max(
      createPersonaBodyShortNameMax,
      `Keep it under ${createPersonaBodyShortNameMax} characters`,
    ),
  voice: z
    .string()
    .trim()
    .max(
      createPersonaBodyVoiceMax,
      `Keep it under ${createPersonaBodyVoiceMax} characters`,
    ),
  timezone: z.string(),
});
export type PersonaValues = z.infer<typeof PersonaSchema>;

export const toValues = (persona?: PersonaDto): PersonaValues => ({
  name: persona?.name ?? '',
  shortName: persona?.shortName ?? '',
  voice: persona?.voice ?? '',
  timezone: persona?.timezone ?? '',
});
